import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import '../styles/pages.css';
import { FaChevronRight } from "react-icons/fa6";

function DoctorDetails() {
    const { id } = useParams();
    const [doctor, setDoctor] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctor_details.php?id=${id}`)
            .then(response => {
                if (response.data.error) {
                    setError(response.data.error);
                } else {
                    setDoctor(response.data);
                }
            })
            .catch(() => setError("Failed to fetch doctor details."));
    }, [id]);

    if (error) return <p>{error}</p>;
    if (!doctor) {

        return (
            <>
                <Navbar />
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "50vh" }}>
                    <div className="spinner"></div>
                </div>
                <Footer />
            </>
        );
    }

    console.log("doctors data : ", doctor)


    const departmentUrlMap = {
        "Obstetrics, Gynaecology and Fetal Medicine": "/gynaecology",
        "Emergency Medicine & Trauma Care": "/emergency-medicine",
        "Paediatrics & Paediatrics Surgery": "/paediatrics-and-paediatrics-surgery",
        "Neonatology": "/neonatology",
        "General Medicine": "/general-medicine",
        "Dental, Oral & Maxillofacial Surgery": "/dental",
        "General Surgery": "/general-surgery",
        "Orthopaedics, Joint Replacement and Arthroscopy": "/orthopaedics",
        "ENT & Audiology": "/ent-audiology",
        "Plastic and Micro Vascular Surgery": "/plastic-surgery",
        "Dermatology": "/dermatology",
        "Ophthalmology": "/ophthalmology",
        "Cardiology": "/cardiology",
        "Neuro Science": "/neurology",
    };

    return (
        <>
            <Navbar />

            <div className="doctor-details-section">

                <img src={doctor.image_url} alt={doctor.name} className="doctor-details-img" />

                <div>
                    <h4>{doctor.name}</h4>
                    <h5>{doctor.designation}</h5>
                    <p>
                        <Link to={departmentUrlMap[doctor.department] || "/"}>
                            {doctor.department}
                        </Link>
                    </p>

                    {doctor.bio && (
                        <>
                            <h5>About</h5>

                            <p dangerouslySetInnerHTML={{ __html: doctor.bio }}></p>
                        </>
                    )}

                    {doctor.professional_qualification && (
                        <>
                            <h5>Professional Qualifications</h5>

                            <p>{doctor.professional_qualification}</p>
                        </>
                    )}

                    {doctor.achievements && (
                        <>
                            <h5>Achievements and Expertise</h5>

                            <p dangerouslySetInnerHTML={{ __html: doctor.achievements }}></p>
                        </>
                    )}

                    {doctor.awards && (
                        <>
                            <h5>Awards and Recognitions</h5>

                            <p dangerouslySetInnerHTML={{ __html: doctor.awards }}></p>
                        </>
                    )}

                    {doctor.languages && (
                        <>
                            <h5>Languages</h5>

                            <p>{doctor.languages}</p>
                        </>
                    )}

                    {doctor.available_time && (
                        <>
                            <h5>Available Time</h5>

                            {doctor.available_time?.split('<br>').map((slot, index) => (
                                <div key={index}>
                                    {/* Mobile view: break at '&' */}
                                    <div className="doctor-avaiable-time-mobile">
                                        {slot.split('&').map((part, i) => (
                                            <p key={i}>
                                                {part.trim()}{i < slot.split('&').length - 1 && ' &'}
                                            </p>
                                        ))}
                                    </div>

                                    {/* Desktop view */}
                                    <p className="doctor-avaiable-time" style={{margin: "0.5rem 0"}}>
                                        {slot.trim()}
                                    </p>
                                </div>
                            ))}
                        </>
                    )}

                    {parseInt(doctor.appointment_enabled) === 1 && (
                        <p>
                            <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                Book An Appointment <FaChevronRight />
                            </a>
                        </p>
                    )}

                    <p className="goBack" onClick={() => navigate(-1)}>
                        Go Back <FaChevronRight />
                    </p>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default DoctorDetails;
